import { IntegrationScript } from "../lib/IntegrationScript"

// https://elvent.firstpromoter.com/instructions/javascript?onboarding=true&integrate=true

const inlineScript = `(function(w){w.fpr=w.fpr||function(){w.fpr.q = w.fpr.q||[];w.fpr.q[arguments[0]=='set'?'unshift':'push'](arguments);};})(window);
fpr("init", {cid:"du8suc8v"});
fpr("click");`

export const FirstPromoterTag = () => {
  return (
    <>
      <script dangerouslySetInnerHTML={{ __html: inlineScript }} />
      <IntegrationScript id="first_promoter" src="https://cdn.firstpromoter.com/fpr.js" />
    </>
  )
}
